<template>
  <div id="menu-assets" role="tabpanel" class="tab-pane show" aria-labelledby="assets-tab">
    <div class="submenu-nav-header">
      <div class="my-1 d-lg-none"></div>
      <h4 class="mb-0">Asset Management</h4>
      <small class="mb-1"><i>Manage your Vehicles and Drivers</i></small>
    </div>
    <ul class="nav nav-pills" id="submenu-assets" role="tablist">
      <li v-if="security.canView('vehicles')" class="nav-item">
        <a id="sm-vehicles-tab" class="nav-link submenu-nav-pill"
           :class="{active: isMenuTabActive('vehicles')}" data-toggle="tab"
           href="#sm-vehicles"
           role="tab" aria-controls="sm-vehicles"
           aria-selected="true">
          <fa-icon icon="car"/>&nbsp;&nbsp;Vehicles</a>
      </li>
      <li v-if="security.canView('drivers')" class="nav-item">
        <a id="sm-drivers-tab" class="nav-link submenu-nav-pill"
           :class="{active: isMenuTabActive('drivers')}" data-toggle="tab"
           href="#sm-drivers"
           role="tab" aria-controls="sm-drivers"
           aria-selected="false">
          <fa-icon icon="id-card"/>&nbsp;&nbsp;Drivers</a>
      </li>
    </ul>
    <div class="tab-content">
      <hr class="mt-2">
      <div id="sm-vehicles" role="tabpanel" class="tab-pane" :class="{active: isMenuTabActive('vehicles')}">
        <div class="row">
          <div v-if="security.canCreate('vehicles')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.vehicleCreate.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.vehicleCreate.icon" :class="menu.vehicleCreate.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.vehicleCreate.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.vehicleCreate.details }}</p>
              </div>
            </router-link>
          </div>
          <div class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.vehicleFind.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.vehicleFind.icon" :class="menu.vehicleFind.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.vehicleFind.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.vehicleFind.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
        <div class="row">
          <div v-if="security.canCreate('vehicle_expenses')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.vehicleExpenses.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.vehicleExpenses.icon" :class="menu.vehicleExpenses.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.vehicleExpenses.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.vehicleExpenses.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
        <!-- Vehicle Groups Section -->
        <div class="row">
          <h5 class="col-12 mt-3 mb-0"><fa-icon icon="cubes" />&nbsp;Vehicle Groups</h5>
          <div class="col-12"><hr class="mb-3 mt-2"></div>
          <div v-if="security.canCreate('vehicle_groups')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.vehicleGroupCreate.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.vehicleGroupCreate.icon" :class="menu.vehicleGroupCreate.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.vehicleGroupCreate.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.vehicleGroupCreate.details }}</p>
              </div>
            </router-link>
          </div>
          <div class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.vehicleGroupFind.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.vehicleGroupFind.icon" :class="menu.vehicleGroupFind.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.vehicleGroupFind.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.vehicleGroupFind.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div id="sm-drivers" role="tabpanel" class="tab-pane" :class="{active: isMenuTabActive('drivers')}">
        <div class="row">
          <div v-if="security.canCreate('drivers')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.driverCreate.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.driverCreate.icon" :class="menu.driverCreate.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.driverCreate.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.driverCreate.details }}</p>
              </div>
            </router-link>
          </div>
          <div class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.driverFind.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.driverFind.icon" :class="menu.driverFind.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.driverFind.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.driverFind.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import menuItems from '@/common/menu'
import security from '@/common/security'

import {
  NAV_GET_MENU_OPEN,
  NAV_SET_MENU_OPEN
} from '@/store/navigation/nav.types'

export default {
  data () {
    return {
      menu: menuItems,
      activeMenuTab: ''
    }
  },

  mounted () {
    if (security.canView('vehicles')) {
      this.activeMenuTab = 'vehicles'
    } else if (security.canView('vehicle_expenses')) {
      this.activeMenuTab = 'vehicle_expenses'
    } else if (security.canView('drivers')) {
      this.activeMenuTab = 'drivers'
    }
  },

  methods: {
    setMenuState () {
      this.$store.commit(NAV_SET_MENU_OPEN, !this.getMenuState())
    },

    getMenuState () {
      return this.$store.getters[NAV_GET_MENU_OPEN]
    },

    isMenuTabActive (tabName) {
      return tabName === this.activeMenuTab
    }
  },

  components: {
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/navigation/NavMenuAssets.vue